import { IState } from './types';
import { GetterTree } from 'vuex';
import { IRootState } from '@/store/types';
import mutations from './mutations';

const state: IState = {
  notebookMap: new Map()
};

export default {
  namespaced: true,
  state,
  mutations
};
